export const envProd = {
    websiteUrl: "https://www.boardgamesfinder.com",
    apiBaseUrl: "https://api2.boardgamesfinder.com",
    apiVersion: "v1",
    auth: {
        url: "https://bgf-prod-vnzwh5.eu1.zitadel.cloud",
        client_id: "369253091314333117"
    }
}